import { HttpClient, HttpStatusCode } from 'data/protocols/http';
import { InvalidCredentialsError, UnexpectedError } from 'domain/errors';
import { GetGroupByIdUseCaseInterface } from 'domain/usecases';

export class RemoteGetGroupById implements GetGroupByIdUseCaseInterface {
  constructor(
    private readonly url: string,
    private readonly httpClient: HttpClient<GetGroupByIdUseCaseInterface.Result>,
  ) {}

  async execute(
    params: GetGroupByIdUseCaseInterface.Params,
  ): Promise<GetGroupByIdUseCaseInterface.Result> {
    const httpResponse = await this.httpClient.request({
      method: 'get',
      url: `${this.url}/${params.groupId}`,
    });

    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok:
        return httpResponse.body;
      case HttpStatusCode.forbidden:
        throw new InvalidCredentialsError();
      default:
        throw new UnexpectedError();
    }
  }
}
